import React, { useEffect } from 'react'
import styles from './iframe-style.css'
import type { IframeViewModel } from '../../view-models/IframeViewModel'
import Spinner from '../../components/Spinner/Spinner'
type Props = IframeViewModel

const Iframe = ({ src, height, noScroll, ...rest }: Props) => {
  // Hooks are supported by the used React library, but flow-bin is so old that there's no support.
  // Upgrading flow-bin from 0.85.0 (used at the time of writing) to 0.87.0 (which has hook support)
  // requires a lot of changes to the existing code base.
  const [isLoaded, setIsLoaded] = React.useState(false)
  const [isReady, setIsReady] = React.useState(false)
  useEffect(() => {
    setIsReady(true)
  }, [])
  if (!src) return null
  return (
    <div
      className={styles.iframe}
      style={{
        height: height || 400,
      }}
    >
      {!isLoaded && <div className={styles.spinnerContainer}><Spinner /></div>}
      {isReady ? (
        <iframe
          {...rest}
          title={src}
          height={height || 400}
          width={'100%'}
          scrolling={noScroll ? 'no' : 'yes'}
          src={src}
          style={{
            overflow: noScroll ? 'hidden' : 'auto',
          }}
          className={isLoaded ? styles.isLoaded : undefined}
          onLoad={() => setIsLoaded(true)}
        />
      ) : null}
    </div>
  )
}

Iframe.displayName = 'Iframe'
export default Iframe